import { Injectable } from '@angular/core';
import { ECalenderNoteType } from './user-calendar.model';

@Injectable({ providedIn: 'root' })
export class UserCalendarHelperService {
  readonly typeToColour: Record<ECalenderNoteType, string> = {
    [ECalenderNoteType.meeting]: `#f50`,
    [ECalenderNoteType.note]: `#ffc000`,
    [ECalenderNoteType.task]: `#0b00ff`,
  } as const;
}
